import React from 'react';
import styled from 'styled-components';
import { useSlideData } from '@context/slide-data';
import { Button } from '../../styles';
import { ScrollBarStyle } from '@slides/styles';
import { 
    IntroScript, 
    YourAnalysisScript, 
    WeCanHelpScript, 
    TermOptionsScript,
    ModificationScript, 
    SummaryScript, 
    AdditionalInfoScript, 
    CreditImpactScript } from '../../scripts';

// TODO: update height to calculate 100% minus navbar height (flexible) instead of pixels
const ScriptStyle = styled.div`
    display: ${({showScript}) => showScript ? 'flex' : 'none' };
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background: #F9F9F9;
    border: 1px solid #7F9DB3;
    box-sizing: border-box;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 16px;
    transition: 0.3s linear;
    position: absolute;
    overflow-y: auto;
    z-index: 5;
    width: 100%;
    max-width: 350px;
    font-size: ${props => props.theme.smallFont};
    font-family: ${props => props.theme.sansSerif};
    overflow-x: hidden;
    right: 0;
    top: 0;
    height: 562px;
    div {
        margin: 5px 0;
    };
    &.active {
        display: flex;
    }
    h4 {
        align-self: flex-start;
    }
   ${ScrollBarStyle}
`;

const HideScript = styled(Button)`
    width: 100%;
    background: ${props => props.theme.lightGrey};
    justify-content: flex-end;
    padding: 8px 12px;
    color: #0A1E28;
    text-transform: uppercase;
    margin: 10px 0;
`;

// Will slideId be reliable? May have to use name (via a slideData context)
export const PresentationScript = ({ showScript, setShowScript }) => {
    const { data } = useSlideData();

    function renderScript(slideId) {
        switch(slideId) {
            case 1:
                return <IntroScript />;
            case 2:
                return <YourAnalysisScript />;
            case 3:
                return <WeCanHelpScript />;
            case 4:
                return <TermOptionsScript  />;
            case 5:
                return <ModificationScript />;
            case 6:
                return <SummaryScript />;
            case 7:
                return <AdditionalInfoScript />;
            case 13:
                return <CreditImpactScript />;
            default:
                return 'Script not available for this slide';
        }
    }

    return (
        <ScriptStyle showScript={showScript}>
            <HideScript onClick={() => setShowScript(false)}>Hide script {'>>'}</HideScript>
            {
                data && renderScript(data.id)
            }
        </ScriptStyle>
    );
};

export default PresentationScript;
